/**
 * Util method that analyzes output of attempted
 * account linking via Plaid. Plaid docs for
 * reference https://plaid.com/docs/link/web
 *
 * @param   {object} options Error with its metadata
 * @param  {object} [options.error] - A nullable object that contains the error type,
 * code, and message of the error that was last encountered by the user.
 * If no error was encountered, error will be null.
 * @param  {object} [options.metadata] - Result of attempted account linking via Plaid
 * @param {Function} onError - onError handler
 *
 * @returns {boolean} - Returns true if account successfully linked
 * and error is null, otherwise returns false.
 */
const isPlaidLinkSuccessful = ({ error, metadata }, onError = () => {}) => {
  if (error) {
    onError(error);
    return false;
  }

  /*
    Handle onSuccess scenario where
    user exits Plaid link flow without error
    but an account is not linked - we do not want to
    consider this a success since no accounts were linked.
    Resources:
    https://github.com/zenbusiness/zenbusiness.com/pull/1392
    https://plaid.com/docs/link/web/#link-web-onsuccess-metadata-accounts
  */
  const metadataStatus = metadata?.status !== null;
  const metadataAccountsLength = metadata?.accounts?.length;

  if (metadataStatus && !metadataAccountsLength) {
    return false;
  }
  return true;
};

export default isPlaidLinkSuccessful;
